module.exports = __webpack_public_path__ + "img/1484236274.4baa8b02.jpg";